import { ApolloClient, InMemoryCache } from '@apollo/client';

export const healthClient = new ApolloClient({
  uri: process.env.REACT_APP_SUBGRAPH_HEALTH_CLIENT,
  cache: new InMemoryCache(),
})

export const helaBlockClient = new ApolloClient({
  uri: process.env.REACT_APP_SUBGRAPH_HELA_BLOCK_CLIENT,
  cache: new InMemoryCache(),
  queryDeduplication: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export const helaTestnetBlockClient = new ApolloClient({
  uri: 'https://subgraph.snapresearch.xyz/subgraphs/name/cytoswap-subgraph',
  cache: new InMemoryCache(),
  queryDeduplication: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export const helaClient = new ApolloClient({
  uri: process.env.REACT_APP_SUBGRAPH_HELA_CLIENT,
  cache: new InMemoryCache({
    typePolicies: {
      Token: {
        // Singleton types that have no identifying field can use an empty
        // array for their keyFields.
        keyFields: false,
      },
      Pool: {
        // Singleton types that have no identifying field can use an empty
        // array for their keyFields.
        keyFields: false,
      },
    },
  }),
  queryDeduplication: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export const helaTestnetClient = new ApolloClient({
  uri: 'https://subgraph.snapresearch.xyz/subgraphs/name/cytoswap-subgraph',
  cache: new InMemoryCache({
    typePolicies: {
      Token: {
        // Singleton types that have no identifying field can use an empty
        // array for their keyFields.
        keyFields: false,
      },
      Pool: {
        // Singleton types that have no identifying field can use an empty
        // array for their keyFields.
        keyFields: false,
      },
    },
  }),
  queryDeduplication: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
})
